export function fitTextarea(element: HTMLTextAreaElement, maxHeight: number) {
  element.style.height = "auto";
  const border = element.offsetHeight - element.clientHeight;
  const contentHeight = element.scrollHeight + border;
  element.style.height = `${Math.min(contentHeight, maxHeight)}px`;
  element.style.overflowY = contentHeight > maxHeight ? "auto" : "hidden";
}
